<div class="new-health-card mb-2">
  <div class="health-card__privacy d-flex align-items-end justify-content-between new-health-card-privacy">
    <span class="health-card__privacy__to-user d-flex align-items-center">
      <img loading="lazy" [src]="product?.products[0]?.ncp_template?.image?.extra_image_1"
        class="privacy-icon-height"
        onerror="this.src='assets/images/game/privacy_lock.svg'"
        alt="privacy icon" />
      <span class="ml-1 secondary-paragraph" [ngStyle]="{'color': product?.products[0]?.ncp_template?.color?.extra_color_1}">{{product?.products[0]?.ncp_template?.text?.extra_text_1}}</span>
    </span>
    <span class="health-card__privacy__availability d-flex flex-column text-right">
      <ng-container *ngIf="!hideTimer">
        <span class="secondary-paragraph" [ngStyle]="{'color': product?.products[0]?.ncp_template?.color?.extra_color_1}">{{mls.languageText.health_card.key1}}</span>
        <div [ngStyle]="{'color': product?.products[0]?.ncp_template?.color?.extra_color_1}" class="timer paragraph-bold">
          {{remainingDuration}}
        </div>
      </ng-container>
    </span>
  </div>
  <div class="d-flex align-items-top">
    <span class="health-card__icon">
      <img loading="lazy" [src]="product?.products[0]?.ncp_template?.image?.icon"
       onerror="this.src='assets/images/game/health.svg'"
       alt="icon" />
    </span>
    <div [ngStyle]="{'color': product?.products[0]?.ncp_template?.color?.text_color}">
      <p class="heading-4 pb-2">{{product?.products[0]?.title}}</p>
      <p class="secondary-paragraph"><span class="color-grey-700">{{product?.products[0]?.description}}</span></p>
    </div>
  </div>
  <div class="health-card__banner" #screen>
    <div class="new-health-card-banner-image">
      <img loading="lazy" [src]="product.products[0].ncp_product[0].image.banner | fitInImg :igs.imageGroup.fitin_1200x1200"
        onerror="this.src='assets/images/game/healthcard.jpg'"
        alt="Health Card" />
    </div>
    <div class="new-health-card-banner-by" [ngStyle]="{'background-color': product?.products[0]?.ncp_product[0]?.template?.color?.card}">
      <p class="p-2 paragraph-bold content" [ngStyle]="{'background-color': product?.products[0]?.ncp_product[0]?.template?.color?.card_cta_another,
      'color': product?.products[0]?.ncp_product[0]?.template?.color?.card_cta}">{{mls.languageText.health_card.key3}} {{dss.user_profile_data?.profile?.first_name+' '+dss.user_profile_data?.profile?.middle_name+' '+dss.user_profile_data?.profile?.last_name}}</p>
    </div>
  </div>
  <div class="health-card__actions d-flex align-items-center justify-content-between" *ngIf="(this.mls.featureOnOffList.featureList.healthCardDownloadAndShare.value || !mls.userLoginFlow)">
    <button [disabled]="loading" class="btn-design medium outline w-50 mr-2" [ngStyle]="{'background-color': product?.products[0]?.ncp_product[0]?.template?.color?.like_comment_share}"  [appAnalyticsEvent]="analyticsShareData"
    (click)="shareProduct()">
      <img *ngIf="!loading" src="assets/themes/icons/share.svg" alt="share-icon">
      <img *ngIf="loading" src="assets/themes/icons/primary-loader.gif" width="20" height="20" />
      {{mls.languageText.health_card.key2}}
    </button>
    <button [disabled]="downLoading"  [ngStyle]="{'background': product?.products[0]?.ncp_product[0]?.template?.color?.title}" (click)="download()"
      class="btn-design filled medium w-50 ml-2"  [appAnalyticsEvent]="analyticsDownloadData">
      <img *ngIf="downLoading" src="assets/themes/icons/primary-loader.gif" width="20" height="20" /> {{product?.products[0]?.ncp_product[0]?.template?.text.product_button_text}}</button>
  </div>
</div>
